import type { TFunction } from 'i18next';
import type {
  FormSegment,
  LookalikeSegmentDefinition,
} from '../../../../../../../../../../modules/audiences/AudienceForm/types';
import { isLookalikeSegmentDefinition } from '../../../utils';
import { getDataTypeName } from './getDataTypeName';
import { getLookalikeReachRange } from './getLookalikeReachRange';

type SegmentMetadata = {
  name: string;
  id: string;
  reach?: number | null;
  category: string;
  type: string;
  lookalikeReachRange: string | null;
  isSeedSegment: boolean;
  providerName?: string;
  regionCodes: string[];
  countryCodes: string[];
};

const extractRegionCodes = (regions: FormSegment['regions']): string[] => {
  if (!regions) return [];
  if (typeof regions === 'string') return [regions];

  return regions.flatMap(region => (region?.region_code ? [region.region_code] : []));
};

const extractCountryCodes = (countries: FormSegment['countries']): string[] => {
  if (!countries) return [];
  if (typeof countries === 'string') return [countries];

  return countries.flatMap(country => (country?.country_code ? [country.country_code] : []));
};

export const createSegmentMetadata = (
  segment: FormSegment | LookalikeSegmentDefinition,
  t: TFunction,
  selectedAccountId: string,
  providerName?: string
): SegmentMetadata => {
  if (isLookalikeSegmentDefinition(segment)) {
    return {
      name: segment.lookalike_name,
      id: segment.id,
      reach: 0,
      category: 'lookalike',
      type: '',
      lookalikeReachRange: getLookalikeReachRange(segment, t),
      isSeedSegment: !!segment.lookalike_segment_seed_aggregate,
      providerName,
      regionCodes: [],
      countryCodes: [],
    };
  }

  return {
    name: segment.name,
    id: segment.id,
    reach: segment.reach,
    category: segment.category || '',
    type: getDataTypeName(segment, t, selectedAccountId),
    lookalikeReachRange: null,
    isSeedSegment: false,
    providerName: undefined,
    regionCodes: extractRegionCodes(segment.regions),
    countryCodes: extractCountryCodes(segment.countries),
  };
};
